import React, { FC, useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import { testimonials } from "@/data/testimonials";
import LucideIcon from "@/utils/LucideIcon";
import { subheadingParent, supportedText } from "@/animation/textAnimation";
import { TestimonialCard } from "@/components/TestimonialCard/TestimonialCard";

const TestimonialCarousel: FC = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    if (containerRef.current) {
      const totalWidth = containerRef.current.scrollWidth / 2;
      setWidth(totalWidth);
    }
  }, [testimonials]);

  const speed = 50;
  const duration = width / speed;

  return (
    <section className="px-4 mx-auto space-y-10">
      <div className="px-0 overflow-hidden">
        <div className="container text-center md:text-start mb-20 px-14">
          <motion.div>
            <motion.h2 {...subheadingParent}>
              <div className="flex items-center md:text-left justify-center md:justify-start mb-4">
                <LucideIcon
                  name="Route"
                  className="w-10 h-10 text-blue-900 hover:text-blue-900 hidden md:inline-block mr-3"
                />
                <h2 className="text-4xl md:text-5xl font-bold font-inter text-secondary-gradient bg-clip-text text-transparent pb-1">
                  What Our Clients Say !
                </h2>
              </div>
            </motion.h2>
            <motion.div
              className="w-24 h-1 bg-secondary-gradient mx-auto md:mx-0 md:ml-14 rounded-xl"
              initial={{ width: 0 }}
              whileInView={{ width: 96 }}
              transition={{ duration: 0.8, delay: 0.5 }}
              viewport={{ amount: 0.2 }}
            ></motion.div>
            <motion.p
              {...supportedText}
              className="text-xl text-gray-600 max-w-3xl leading-relaxed font-inter"
            >
              Trusted by businesses across India for exceptional customization
              services
            </motion.p>
          </motion.div>
        </div>
        {/* Carousel Section */}
        <div className="relative pb-6 w-full overflow-hidden">
          <div className="absolute left-0 top-0 h-full w-16 md:w-20 lg:w-40 bg-gradient-to-r from-white lg:via-white to-transparent z-10 pointer-events-none" />

          <div className="absolute right-0 top-0 h-full w-16 md:w-20 lg:w-40 bg-gradient-to-l from-white lg:via-white to-transparent z-10 pointer-events-none" />
          {/* Scrolling testimonial cards */}
          <motion.div
            ref={containerRef}
            className="flex gap-6 w-max"
            animate={{ x: [0, -width] }}
            transition={{
              repeat: Infinity,
              duration: duration,
              ease: "linear" as const,
            }}
          >
            {[...testimonials, ...testimonials].map((testimonial, index) => (
              <div
                key={`${testimonial.id}-${index}`}
                className="flex items-center justify-center min-w-[280px] max-w-[320px] md:min-w-[300px] md:max-w-[340px]"
              >
                <TestimonialCard testimonial={testimonial} />
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialCarousel;
